import React from 'react';

import { Key } from '../keys';

interface Props {
  onClose: VoidFunction;
  onNext: VoidFunction;
  onPrevious: VoidFunction;
}

export const useLightboxKeyboardControls = ({ onClose, onNext, onPrevious }: Props) => {
  const handleEscapeKey = React.useCallback(
    (event: KeyboardEvent) => {
      event.stopPropagation();
      onClose();
    },
    [onClose],
  );

  const handleLeftKey = React.useCallback(
    (event: KeyboardEvent) => {
      event.stopPropagation();
      onPrevious();
    },
    [onPrevious],
  );

  const handleRightKey = React.useCallback(
    (event: KeyboardEvent) => {
      event.stopPropagation();
      onNext();
    },
    [onNext],
  );

  const handleKeyDown = React.useCallback(
    (event: KeyboardEvent) => {
      const handlers: Record<string, Maybe<(event: KeyboardEvent) => void>> = {
        [Key.ESCAPE]: handleEscapeKey,
        [Key.LEFT]: handleLeftKey,
        [Key.RIGHT]: handleRightKey,
      };

      handlers[event.code]?.(event);
    },
    [handleLeftKey, handleRightKey, handleEscapeKey],
  );

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
};
